import React from "react";

import { FlatRate } from "../../constants/aquafina";
import { CoverageRow, MessageRow } from "../table/rows";
import { CoverageCell } from "../table/cells";
import { RangeIterator } from "../../utils";

const resolveFundingTypeInfo = (flatRates: FlatRate[]) => {
  if (flatRates.length === 0) return null;

  const fundingType = flatRates[0].fundingType;

  const isConsistent = flatRates.every(
    (rate) => rate.fundingType === fundingType,
  );

  if (!isConsistent) {
    return "inconsistent";
  }

  if (fundingType === null) {
    return "rate";
  }
  return fundingType;
};

const FlatRates = ({ rates }: { rates: FlatRate[] }) => {
  const fundingTypeInfo = resolveFundingTypeInfo(rates);
  switch (fundingTypeInfo) {
    case null:
      return null;
    case "rate":
      return (
        <>
          <CoverageRow label="Rate Unit">
            {RangeIterator(rates.length, (index) => (
              <CoverageCell value={rates[index].rateUnit} key={index} />
            ))}
          </CoverageRow>
          <CoverageRow label="Rates" isWhite>
            {RangeIterator(rates.length, (index) => (
              <CoverageCell value={rates[index].value} key={index} />
            ))}
          </CoverageRow>
        </>
      );
    case "ASO Fee":
    case "ATP Fee":
      return (
        <CoverageRow label={fundingTypeInfo}>
          {RangeIterator(rates.length, (index) => (
            <CoverageCell value={rates[index].pepm} key={index} />
          ))}
        </CoverageRow>
      );
    case "inconsistent":
      return (
        <MessageRow
          colSpan={rates.length}
          message="This section cannot be displayed due to inconsistent data"
        />
      );
  }
};

export default FlatRates;
